import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormHelperText,
  Typography,
} from "@mui/material";
import { ToastContext } from "../../contexts/toast-context";
import { useDeleteUser } from "../../api/use-user";

export const DeleteUser = ({ open, user, onClose }) => {
  const { t } = useTranslation(["user", "common"]);
  const { showSuccess } = useContext(ToastContext);

  const [{ loading, error }, execute] = useDeleteUser(user?.id);

  const handleDelete = async () => {
    await execute();
    showSuccess(t("successfulAction"));
    onClose();
  };

  return (
    <Dialog open={open} onClose={() => onClose()} maxWidth="sm" fullWidth>
      <DialogTitle>{t("deleteUser")}</DialogTitle>
      <DialogContent>
        <Typography variant="body">
          {t("deleteUserConfirm", { name: user?.name })}
        </Typography>
        {error && (
          <FormHelperText error>
            {t("genericError", { action: t("deleteUser") })}
          </FormHelperText>
        )}
        {loading && (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <CircularProgress size={30} sx={{ mt: 3 }} />
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onClose()} disabled={loading}>
          {t("cancel")}
        </Button>
        <Button onClick={handleDelete} disabled={loading} autoFocus>
          {t("delete")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
